export default {
  // Settings Dashboard
  "settings.jumbotron.title": "Asetukset",
  "settings.jumbotron.description": "Määritä järjestelmäasetukset ja liiketoimintaparametrit.",
  "settings.search_placeholder": "Hae asetuksia...",
  "settings.desc.user_settings": "Profiilikuva, salasana ja tiliasetukset",
  "settings.desc.company_info": "Yrityksen nimi, osoite ja yhteystiedot",
  "settings.desc.bank_accounts": "IBAN, BIC ja pankkitilinumerot",
  "settings.desc.einvoice": "Verkkolaskuosoite ja operaattori",
  "settings.desc.accounting_settings": "Automaattiset tositteet ja oletus-ALV",
  "settings.desc.vat_configuration": "ALV-kannat ja veroasetukset",
  "settings.desc.coa_configuration": "Tilikartan rakenne",
  "settings.desc.coa_role_configs_configuration": "Tilien roolimääritykset",
  "settings.desc.coa_groups_configuration": "Tiliryhmien määritykset",
  "nav.coa_groups_configuration": "Tiliryhmät",
  "settings.desc.financial_years_configuration": "Tilikaudet",
  "settings.desc.voucher_types_configuration": "Tositelajien määritykset",
  "settings.desc.entry_types_configuration": "Vientilajit: hankinta, poisto, lainan lyhennys ja muut tositerivien lajit",
  "nav.dimensions_configuration": "Dimensiot",
  "nav.charge_financing_balances": "Vastikerahoituksen jäämät",
  "settings.desc.dimensions_configuration": "Kirjanpidon dimensiot (kustannuspaikat, projektit, jne.)",
  "settings.desc.currencies_configuration": "Valuuttakoodit ja kurssit",
  "nav.exchange_rates": "Valuuttakurssit",
  "settings.desc.exchange_rates": "EKP:n päivittäiset valuuttakurssit",
  "settings.desc.units_configuration": "Mittayksiköt",
  "settings.desc.stocks": "Varastopaikat",
  "settings.desc.product_groups": "Tuoteryhmien määritykset",
  "settings.desc.contact_groups": "Kumppaniryhmien määritykset",
  "settings.desc.metered_units": "Mittaroidut kohteet ja niiden haltijat",
  "settings.desc.payment_terms_configuration": "Maksuehtojen määritykset",
  "settings.desc.payment_methods_configuration": "Pankkitilit ja maksutavat",
  "settings.desc.transfer_invoices": "Lisää ennakot ja saatavat alkusaldoiksi",
  "settings.desc.employees": "Työntekijätiedot",
  "settings.desc.departments": "Osastorakenne",
  "settings.desc.expense_categories_configuration": "Kululajien määritykset",
  "settings.desc.tenant_users": "Hallitse yrityksen käyttäjiä ja rooleja",
  "settings.desc.role_management": "Määritä roolit ja moduulien käyttöoikeudet",
  "settings.desc.export_data": "Vie yrityksen tiedot",
  "nav.salaries_settings": "Palkat - Asetukset",
  "settings.desc.salaries_settings": "Palkanlaskentapalvelun asetukset",
  "settings.desc.stages_matrix": "Hallitse tehtävävaiheita ja määritä ne projekteittain",
  "settings.desc.project_tags": "Hallitse tehtävien luokitteluun käytettäviä tunnisteita",
  "settings.desc.project_templates": "Määritä uusiokäyttöisiä projektipohjia, jotka esitäyttävät tehtävät uusiin projekteihin",
  "settings.module.maventa": "Maventa",
  "settings.module.github_integration": "GitHub",
  "settings.module.metered_billing": "Mittaroitu laskutus",
  "settings.desc.github_integration": "Linkitä PR:t ja committit tehtäviin; sulje tehtävät mergetessä",
  "settings.module.company": "Yritys",
  "settings.module.accounting": "Kirjanpito",
  "settings.module.invoicing": "Laskutus",
  "settings.module.purchasing": "Ostot",
  "settings.module.inventory": "Varasto",
  "settings.user_groups": "Käyttäjäryhmät",
  "settings.desc.user_groups": "Hallitse käyttäjäryhmiä hyväksyntöjä ja muita työnkulkuja varten",
  "settings.purchase_invoice_approval_rules": "Ostolaskujen hyväksyntäsäännöt",
  "settings.desc.purchase_invoice_approval_rules": "Hyväksyntäsäännöt ja summarajat ostolaskuille",
  "settings.module.crm": "CRM",
  "settings.module.hr": "HR",
  "settings.module.salaries": "Palkat",
  "settings.module.projects": "Projektit",

  // Settings
  "settings.title": "Asetukset",
  "settings.billing_info": "Laskutustiedot",
  "settings.bank_details": "Pankkitiedot",
  "settings.einvoice": "Verkkolasku",
  "settings.security": "Turvallisuus",
  "settings.change_password": "Vaihda salasana",
  "settings.company_logo": "Yrityksen logo",
  "settings.upload_logo": "Lataa logo",
  "settings.remove_logo": "Poista logo",
  "settings.company_info": "Yrityksen tiedot",
  "settings.email": "Sähköposti",
  "settings.billing_name": "Yrityksen nimi",
  "settings.phone": "Puhelin",
  "settings.billing_street": "Katuosoite",
  "settings.billing_postcode": "Postinumero",
  "settings.billing_city": "Kaupunki",
  "settings.billing_vat_number": "Y-tunnus",
  "settings.bank_name": "Pankin nimi",
  "settings.iban": "IBAN",
  "settings.bic": "BIC",
  "settings.einvoice_address": "Verkkolaskuosoite",
  "settings.einvoice_operator": "Verkkolaskuoperaattori",
  "settings.current_password": "Nykyinen salasana",
  "settings.new_password": "Uusi salasana",
  "settings.confirm_password": "Vahvista salasana",
  "settings.update_password": "Päivitä salasana",
  "settings.save_success": "Asetukset tallennettu onnistuneesti",
  "settings.save_error": "Virhe asetusten tallennuksessa",
  "settings.password_success": "Salasana päivitetty onnistuneesti",
  "settings.password_error": "Virhe salasanan päivityksessä",
  "settings.password_mismatch": "Salasanat eivät täsmää",
  "settings.password_requirements": "Salasanan on oltava vähintään 6 merkkiä",
  "settings.profile_photo": "Profiilikuva",
  "settings.upload_photo": "Lataa kuva",
  "settings.photo_uploaded": "Kuva ladattu onnistuneesti",
  "settings.photo_deleted": "Kuva poistettu",
  "settings.photo_upload_error": "Kuvan lataus epäonnistui",
  "settings.photo_delete_error": "Kuvan poisto epäonnistui",
  "settings.invalid_image_type": "Virheellinen kuvatyyppi. Käytä JPEG-, PNG-, GIF- tai WebP-muotoa",
  "settings.image_too_large": "Kuva on liian suuri. Enimmäiskoko on 5 Mt",
  "settings.click_to_upload": "Napsauta kuvaa vaihtaaksesi",

  // Currencies
  "currencies.title": "Valuutat",
  "currencies.create": "Luo valuutta",
  "currencies.edit": "Muokkaa valuuttaa",
  "currencies.code": "Valuuttakoodi",
  "currencies.marginal": "Marginaali",
  "currencies.coa_sales_loss": "Myynnin kurssitappiotili",
  "currencies.coa_sales_profit": "Myynnin kurssivoittotili",
  "currencies.coa_purch_loss": "Oston kurssitappiotili",
  "currencies.coa_purch_profit": "Oston kurssivoittotili",
  "exchange_rates.currency": "Valuutta",
  "exchange_rates.rate": "Kurssi (1 EUR =)",
  "exchange_rates.date": "Päivä",
  "exchange_rates.source": "Lähde",
  "exchange_rates.as_of_date": "Päivämäärä",
  "exchange_rates.showing_rates_for": "Kurssit päivälle {{date}}",
  "exchange_rates.history_title": "{{currency}} kurssikehitys (1 EUR =)",
  "exchange_rates.no_history": "Ei kurssihistoriaa tälle valuutalle",
  "exchange_rates.select_tenant": "Valitse yritys nähdäksesi valuuttakurssit",
  "exchange_rates.error.loading": "Valuuttakurssien lataus epäonnistui",
  "currencies.select_tenant": "Valitse yritys nähdäksesi valuutat.",
  "currencies.delete.confirm": "Haluatko varmasti poistaa tämän valuutan?",
  "currencies.validation.code_required": "Valuuttakoodi on pakollinen",
  "currencies.validation.code_length": "Valuuttakoodin on oltava 3 merkkiä",
  "currencies.validation.marginal_required": "Marginaali on pakollinen",
  "currencies.validation.marginal_min": "Marginaalin on oltava vähintään 0",
  "currencies.error.loading": "Virhe valuutan lataamisessa",
  "currencies.error.saving": "Virhe valuutan tallennuksessa",
  "currencies.deleted": "Valuutta poistettu",
  "currencies.error.deleting": "Virhe valuutan poistamisessa",
  "currencies.bulk.delete": "Poista valitut",
  "currencies.bulk.delete_confirm": "Haluatko varmasti poistaa {{count}} valuuttaa?",
  "currencies.bulk.deleted": "Valuutat poistettu",
  "currencies.bulk.delete_error": "Virhe valuuttojen poistamisessa",

  // Payment Terms
  "payment_terms.title": "Maksuehdot",
  "payment_terms.new": "Uusi maksuehto",
  "payment_terms.create": "Luo uusi maksuehto",
  "payment_terms.edit": "Muokkaa maksuehtoa",
  "payment_terms.code": "Koodi",
  "payment_terms.code_required": "Koodi on pakollinen tieto",
  "payment_terms.code_max_length": "Koodi voi olla korkeintaan 20 merkkiä",
  "payment_terms.description": "Kuvaus",
  "payment_terms.description_required": "Kuvaus on pakollinen tieto",
  "payment_terms.description_max_length": "Kuvaus voi olla korkeintaan 255 merkkiä",
  "payment_terms.payment_days": "Maksupäivät",
  "payment_terms.payment_days_min": "Maksupäivien tulee olla vähintään 0",
  "payment_terms.payment_days_validate": "Maksupäivien tulee olla kokonaisluku",
  "payment_terms.is_default": "Oletusmaksuehto",
  "payment_terms.loading_error": "Virhe maksuehdon lataamisessa",
  "payment_terms.save_error": "Virhe maksuehdon tallennuksessa",
  "payment_terms.delete.confirm": "Haluatko varmasti poistaa tämän maksuehdon?",
  "payment_terms.delete_error": "Virhe maksuehdon poistamisessa",
  "payment_terms.deleted": "Maksuehto poistettu",
  "payment_terms.error.deleting": "Virhe maksuehdon poistamisessa",
  "payment_terms.bulk.delete": "Poista valitut",
  "payment_terms.bulk.delete_confirm": "Haluatko varmasti poistaa {{count}} maksuehtoa?",
  "payment_terms.bulk.deleted": "Maksuehdot poistettu",
  "payment_terms.bulk.delete_error": "Virhe maksuehtojen poistamisessa",

  // VAT Configuration
  "vat.code": "Koodi",
  "vat.percent": "Prosentti %",
  "vat.description": "Kuvaus",
  "vat.sale_account": "Myyntitili",
  "vat.buyin_account": "Ostotili",
  "vat.type": "Tyyppi",
  "vat.group_id": "Ryhmä ID",
  "vat.select_tenant": "Valitse yritys hallitaksesi ALV-asetuksia.",
  "vat.state.active": "Aktiivinen",
  "vat.state.deleted": "Poistettu",
  "vat.state.invalid": "Virheellinen",
  "vat.confirm_delete_message": "Haluatko varmasti poistaa tämän ALV-kannan?",
  "vat.delete.confirm": "Haluatko varmasti poistaa tämän ALV-kannan?",
  "vat.deleted": "ALV poistettu",
  "vat.error.deleting": "Virhe ALV:n poistamisessa",
  "vat.bulk.delete": "Poista valitut",
  "vat.bulk.delete_confirm": "Haluatko varmasti poistaa {{count}} ALV-kantaa?",
  "vat.bulk.deleted": "ALV-kannat poistettu",
  "vat.bulk.delete_error": "Virhe ALV-kantojen poistamisessa",

  // Financial Years
  "financial_years.name": "Nimi",
  "financial_years.start_date": "Alkupäivä",
  "financial_years.end_date": "Loppupäivä",
  "financial_years.status": "Tila",
  "financial_years.select_tenant": "Valitse yritys hallitaksesi tilikausia.",
  "financial_years.state": "Tila",
  "financial_years.state.open": "Avoin",
  "financial_years.state.locked": "Lukittu",
  "financial_years.lock": "Lukitse",
  "financial_years.unlock": "Avaa lukitus",
  "financial_years.locked": "Tilikausi lukittu",
  "financial_years.unlocked": "Tilikauden lukitus avattu",
  "financial_years.delete.confirm": "Haluatko varmasti poistaa tämän tilikauden?",
  "financial_years.lock.confirm": "Haluatko varmasti lukita tämän tilikauden? Lukittuja tilikausia ei voi muokata.",
  "financial_years.unlock.confirm": "Haluatko varmasti avata tämän tilikauden lukituksen?",
  "financial_years.error.end_before_start": "Loppupäivän on oltava alkupäivän jälkeen",
  "financial_years.error.locking": "Virhe tilikauden lukitsemisessa",
  "financial_years.error.unlocking": "Virhe tilikauden lukituksen avaamisessa",
  "financial_years.deleted": "Tilikausi poistettu",
  "financial_years.error.deleting": "Virhe tilikauden poistamisessa",
  "financial_years.bulk.delete": "Poista valitut",
  "financial_years.bulk.delete_confirm": "Haluatko varmasti poistaa {{count}} tilikautta?",
  "financial_years.bulk.deleted": "Tilikaudet poistettu",
  "financial_years.bulk.delete_error": "Virhe tilikausien poistamisessa",
  "financial_years.voucher_number_start": "Tositenumeroinnin alku",
  "financial_years.voucher_number_end": "Tositenumeroinnin loppu",
  "financial_years.error.number_range": "Numerointiväli on täynnä",
  "financial_years.error.end_less_than_start": "Loppunumeron on oltava suurempi tai yhtä suuri kuin alkunumero",

  // Cost Centres
  "cost_centres.code": "Koodi",
  "cost_centres.description": "Kuvaus",
  "cost_centres.is_default": "Oletuskustannuspaikka",
  "cost_centres.select_tenant": "Valitse yritys hallitaksesi kustannuspaikkoja.",
  "cost_centres.state.active": "Aktiivinen",
  "cost_centres.state.deleted": "Poistettu",
  "cost_centres.delete.confirm": "Haluatko varmasti poistaa tämän kustannuspaikan?",
  "cost_centres.deleted": "Kustannuspaikka poistettu",
  "cost_centres.error.deleting": "Virhe kustannuspaikan poistamisessa",
  "cost_centres.bulk.delete": "Poista valitut",
  "cost_centres.bulk.delete_confirm": "Haluatko varmasti poistaa {{count}} kustannuspaikkaa?",
  "cost_centres.bulk.deleted": "Kustannuspaikat poistettu",
  "cost_centres.bulk.delete_error": "Virhe kustannuspaikkojen poistamisessa",

  // Voucher Types
  "voucher_types.code": "Koodi",
  "voucher_types.description": "Kuvaus",
  "voucher_types.status": "Tila",
  "voucher_types.select_tenant": "Valitse yritys hallitaksesi tositelajeja.",
  "voucher_types.state.active": "Aktiivinen",
  "voucher_types.state.deleted": "Poistettu",
  "voucher_types.delete.confirm": "Haluatko varmasti poistaa tämän tositelajin?",
  "voucher_types.deleted": "Tositelaji poistettu",
  "voucher_types.error.deleting": "Virhe tositelajin poistamisessa",
  "voucher_types.bulk.delete": "Poista valitut",
  "voucher_types.bulk.delete_confirm": "Haluatko varmasti poistaa {{count}} tositelajia?",
  "voucher_types.bulk.deleted": "Tositelajit poistettu",
  "voucher_types.bulk.delete_error": "Virhe tositelajien poistamisessa",

  // COA Role Configs
  "coa_role_config.select_tenant": "Valitse yritys hallitaksesi tilikartan rooliasetuksia.",
  "coa_role_config.role_label": "Rooli",
  "coa_role_config.match_type_label": "Vastaavuustyyppi",
  "coa_role_config.match_value": "Vastaavuusarvo",
  "coa_role_config.match_value_helper": "esim. 2930 parent_code-tyypille, 4000-4999 code_range-tyypille",
  "coa_role_config.match_value_placeholder": "2930 tai 4000-4999",
  "coa_role_config.match_type_helper": "Miten tilit kohdistetaan tahan rooliin",
  "coa_role_config.priority": "Prioriteetti",
  "coa_role_config.priority_helper": "Korkeamman prioriteetin saannot arvioidaan ensin",
  "coa_role_config.requires_vat_link": "Vaatii ALV-linkin",
  "coa_role_config.description": "Kuvaus",
  "coa_role_config.error.loading": "Virhe ladattaessa tilikartan rooliasetuksia",
  "coa_role_config.error.deleting": "Virhe poistettaessa asetusta",
  "coa_role_config.delete.confirm": "Haluatko varmasti poistaa taman asetuksen?",
  "coa_role_config.deleted": "Asetus poistettu",
  "coa_role_config.bulk.delete": "Poista valitut",
  "coa_role_config.bulk.delete_confirm": "Haluatko varmasti poistaa {{count}} asetusta?",
  "coa_role_config.bulk.deleted": "Asetukset poistettu",
  "coa_role_config.bulk.delete_error": "Virhe asetuksien poistamisessa",
  "coa_role_config.seed_defaults.button": "Lisaa oletusasetukset",
  "coa_role_config.seed_defaults.confirm": "Tama lisaa oletusrooliasetukset. Jatka?",
  "coa_role_config.seed_defaults.success": "Oletusasetukset lisatty",
  "coa_role_config.seed_defaults.error": "Virhe oletusasetusten lisaamisessa",
  "coa_role_config.role.vat_payable": "Maksettava ALV",
  "coa_role_config.role.vat_receivable": "Vahennettava ALV",
  "coa_role_config.role.revenue": "Tuotto",
  "coa_role_config.role.expense": "Kulu",
  "coa_role_config.role.asset": "Varallisuus",
  "coa_role_config.role.liability": "Velka",
  "coa_role_config.role.equity": "Oma paaoma",
  "coa_role_config.role.bank": "Pankki",
  "coa_role_config.role.receivables": "Myyntisaamiset",
  "coa_role_config.role.payables": "Ostovelat",
  "coa_role_config.role.turnover": "Liikevaihto",
  "coa_role_config.role.purchases": "Ostot",
  "coa_role_config.role.profit_loss": "Tilikauden tulos",
  "coa_role_config.match_type.code_prefix": "Koodin etuliite",
  "coa_role_config.match_type.parent_code": "Ylatilin koodi",
  "coa_role_config.match_type.code_range": "Koodialue",

  // Payment Methods
  "payment_methods.code": "Koodi",
  "payment_methods.description": "Kuvaus",
  "payment_methods.account_number": "Tilinumero",
  "payment_methods.account": "Tili",
  "payment_methods.iban": "IBAN",
  "payment_methods.bic": "BIC",
  "payment_methods.service_id": "Palvelutunnus",
  "payment_methods.is_default": "Oletusmaksutapa",
  "payment_methods.web_service_enabled": "Web Service -toiminnallisuus päällä",
  "payment_methods.is_advance": "Ennakkomaksutapa (tili on asiakasennakkotili)",
  "payment_methods.select_tenant": "Valitse yritys hallitaksesi maksutapoja.",
  "payment_methods.state.active": "Aktiivinen",
  "payment_methods.state.deleted": "Poistettu",
  "payment_methods.delete.confirm": "Haluatko varmasti poistaa tämän maksutavan?",
  "payment_methods.deleted": "Maksutapa poistettu",
  "payment_methods.error.deleting": "Virhe maksutavan poistamisessa",
  "payment_methods.bulk.delete": "Poista valitut",
  "payment_methods.bulk.delete_confirm": "Haluatko varmasti poistaa {{count}} maksutapaa?",
  "payment_methods.bulk.deleted": "Maksutavat poistettu",
  "payment_methods.bulk.delete_error": "Virhe maksutapojen poistamisessa",
  "payment_methods.banking_changed_warning": "Pankkitietoja on muutettu tai niitä ei ole vielä hyväksytty. Web services -toiminnallisuus on pois käytöstä kunnes ylläpitäjä hyväksyy maksutavan.",
};
